<template lang="pug">
#other-office-online-meeting-register(v-cloak)
  .box
    .box-header.with-border.register-header
      .title
        span オンライン会議詳細

    .box-body.register-body
      //- 日付・時間
      FormLabel(key-name="日時" :value="_startAndEndDatetime")
      //- 会議相手
      FormLabel(key-name="会議相手" :value="_targetFacilityName")
      //- 件名
      FormLabel(key-name="件名" :value="_title")
      //- 内容
      FormLabel(key-name="内容" :value="_text")

      //- エラーメッセージ
      .register-row(v-show="errorMessage")
        .register-group
          .register-value
            .error-message {{ errorMessage }}

    .box-footer.with-border.register-footer
      .buttons
        button.btn.cancel-btn(@click="gotoMeetingList" type="button") キャンセル
  
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { PcUrl } from "@/commons/constants/PcUrl";

import OtherOfficeOnlineMeetingsService, { OtherOfficeOnlineMeetingGetModel } from "@/commons/services/OtherOfficeOnlineMeetings";
import OtherOfficeConnectionsService, { OtherOfficeConnectionGetModel } from "@/commons/services/OtherOfficeConnections";

import FormLabel from "@/pc/components/forms/FormLabel.vue";

import PageLoading from "@/pc/basics/PageLoading.vue";

/**
 * ### 他事業所連携 オンライン会議詳細画面
 */
@Component({
  components: {
    FormLabel,
    PageLoading
  }
})
export default class OnlineMeetingDetail extends Vue {
  /** 待機者ラベルサービス */
  @Inject("OtherOfficeOnlineMeetingsService") meetingsService!: OtherOfficeOnlineMeetingsService;
  /** 他事業所連携管理サービス */
  @Inject("OtherOfficeConnectionsService") otherOfficeConnectionsService!: OtherOfficeConnectionsService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** オンライン会議 */
  meeting: OtherOfficeOnlineMeetingGetModel | null = null;
  /** 会議相手 */
  otherOfficeConnections: Array<OtherOfficeConnectionGetModel> = [];

  /** エラーメッセージ */
  errorMessage: string = "";

  get _startAndEndDatetime(): string {
    if (!this.meeting) {
      return "";
    }
    const startDatetime = this.$dateUtil.convertNumberToString(this.meeting.startDatetime, "yyyy年mm月dd日 hh：MM");
    const endTime = this.$dateUtil.convertNumberToString(this.meeting.endDatetime, "hh：MM");
    return `${startDatetime}～${endTime}`;
  }

  get _targetFacilityName(): string {
    return this.meeting ? this.meeting.targetFacilityName : "";
  }

  get _title(): string {
    return this.meeting ? this.meeting.title : "";
  }

  get _text(): string {
    return this.meeting ? this.meeting.text : "";
  }

  get _notificationMailAddress(): string[] {
    return this.meeting ? this.meeting.notificationMailAddress : [];
  }

  /**
   * ### vue lifecycle created
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const id = Number(this.$route.params.id);
    const targetFacilityId = Number(this.$route.params.targetFacilityId);
    const meeting: OtherOfficeOnlineMeetingGetModel = await this.getMeeting(targetFacilityId, id);
    this.meeting = meeting;

    const otherOfficeConnections: Array<OtherOfficeConnectionGetModel> = await this.getOtherOfficeConnections();
    this.otherOfficeConnections = otherOfficeConnections;

    this.isBusy = false;

    return;
  }

  /** ### 修正対象のオンライン会議を取得する */
  public async getMeeting(targetFacilityId: number, id: number): Promise<OtherOfficeOnlineMeetingGetModel> {
    const response: OtherOfficeOnlineMeetingGetModel = await this.meetingsService.get(userStore, targetFacilityId, id);
    return response;
  }

  /** ### 他事業所連携管理を取得する */
  public async getOtherOfficeConnections(): Promise<Array<OtherOfficeConnectionGetModel>> {
    const response: Array<OtherOfficeConnectionGetModel> = await this.otherOfficeConnectionsService.gets(userStore);
    return response;
  }

  /** ### オンライン会議一覧に遷移する */
  public gotoMeetingList(): void {
    this.$router.push(PcUrl.OtherOfficeOnlineMeetings);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

#other-office-online-meeting-register {
  max-width: 740px;
  margin-left: auto;
  margin-right: auto;

  .mail-address-input {
    .text {
      white-space: pre-wrap;
      word-wrap: break-word;
      margin: 0 !important;
    }
  }

  .register-btn,
  .cancel-btn {
    width: 120px;
  }
}
</style>
